import React, { useEffect } from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTitleDiv = styled("div")({
    display: "flex",
    flexDirection: "row",
});

/**
 * Represents a string tuner component.
 *
 * @param {Object} props - The component props.
 * @param {number} props.stringNumber - The number of the string.
 * @param {string[]} props.stringTunings - The array of string tunings.
 * @param {Function} props.setStringTunings - The function to set the string tunings.
 * @returns {JSX.Element} The string tuner component.
 */
const StringTuner = ({ stringNumber, stringTunings, setStringTunings }) => {
    const notes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
    const [stringTuning, setStringTuning] = React.useState(-1);

    const handleChange = (event) => {
        const newTuning = event.target.value;
        setStringTuning(newTuning);
        //now update the tuning
        handleStringTuningChange(stringNumber - 1, newTuning);
    };

    const findTuningIndex = (stringNumber, tuning, notes) => {
        const tuningNote = tuning[stringNumber - 1];
        return notes.indexOf(tuningNote);
    };

    const handleStringTuningChange = (index, value) => {
        const newStringTunings = [...stringTunings];
        newStringTunings[index] = value;
        setStringTunings(newStringTunings);
    };

    useEffect(() => {
        setStringTuning(notes[findTuningIndex(stringNumber, stringTunings, notes)]);
    }, []);

    return (
        <Box display="block" flexDirection="row" sx={{ width: 'md' }}>
            <StyledTitleDiv>String {stringNumber}: {stringTuning}</StyledTitleDiv>
            {stringTuning !== -1 && (
                <Select
                    value={stringTuning}
                    onChange={handleChange}
                    sx={{ color: "primary.main", flex: "0 0 auto" }}
                >
                    {notes.map((note, index) => (
                        <MenuItem key={index} value={note}>{note}</MenuItem>
                    ))}
                </Select>
            )}
        </Box>
    );
};

export default StringTuner;
